import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { filterUploadFiles } from "./uploadFileRules";

/**
 * Enveloppe le `onUpload` d'un champ fichier (UploadFile, input) : les fichiers
 * refusés sont retirés avant d'atteindre le parent, et le message d'erreur est
 * exposé pour l'afficher à côté du champ.
 *
 *   const { guardOnUpload, fileError } = useUploadFileGuard(extensions);
 *   <UploadFile onUpload={guardOnUpload(handleUpload)} />
 *   <UploadFileError message={fileError} />
 *
 * Le message reste affiché jusqu'au prochain changement de sélection : une
 * sélection sans refus (ou une suppression) l'efface.
 */
export const useUploadFileGuard = (extensions) => {
  const { t } = useTranslation();
  const [fileError, setFileError] = useState(null);

  const guardOnUpload = useCallback(
    (onUpload) => (files) => {
      const result = filterUploadFiles(files, { extensions, t });
      setFileError(result.errorMessage);
      onUpload?.(result.files);
    },
    [extensions, t]
  );

  return { guardOnUpload, fileError };
};

export default useUploadFileGuard;
